<div class="carousel-wrapper">
  <div class="carousel-container">
    <div class="carousel-images">
      <img *ngFor="let image of images; let i = index" [src]="image" [class.active]="i === currentIndex"
        alt="Imagen de carrusel">
    </div>

    <button class="carousel-arrow left" (click)="prevImage()"> ❮ </button>

    <button class="carousel-arrow right" (click)="nextImage()"> ❯ </button>
  </div>
</div>